import { useEffect, useState } from 'react'

export const CONTACT_VALIDATION_DELAY = 200

/** Wait for a pause in typing; invalidate a changed value immediately. */
export function useContactEligibility(complete: boolean, draft: string) {
  const [validatedDraft, setValidatedDraft] = useState(draft)
  useEffect(() => {
    if (!complete) {
      return
    }
    const timer = setTimeout(
      () => setValidatedDraft(draft),
      CONTACT_VALIDATION_DELAY,
    )
    return () => clearTimeout(timer)
  }, [complete, draft])
  return complete && validatedDraft === draft
}
